import { DocumentStatus } from '../../../../api/model/document';
import i18n from '../../../../i18n/config';

export const getStatusValueLabelMap = (): Record<string, string> => ({
  all_open: i18n.t('labels.allOpenStatuses'),
  draft: i18n.t('statuses.draft'),
  for_review: i18n.t('statuses.forReview'),
  for_approval: i18n.t('statuses.forApproval'),
  approved: i18n.t('statuses.approved'),
  approval_declined: i18n.t('statuses.approvalDeclined'),
  effective: i18n.t('statuses.effective'),
  for_periodic_review: i18n.t('statuses.forPeriodicReview'),
  retired: i18n.t('statuses.retired'),
  deleted: i18n.t('statuses.deletedDrafts'),
});

export const getActionValueLabelMap = (): Record<string, string> => ({
  all_actions: i18n.t('labels.allOpenActions'),
  for_training: i18n.t('statuses.forTraining'),
  include_pending_review: i18n.t('statuses.forReview'),
  include_pending_approve: i18n.t('statuses.forApproval'),
  include_pending_make_effective: i18n.t('statuses.approved'),
  include_pending_periodic_review: i18n.t('statuses.forPeriodicReview'),
});

// Legacy exports for backwards compatibility
export const statusValueLabelMap = getStatusValueLabelMap();
export const actionValueLabelMap = getActionValueLabelMap();

export const defaultActionFilterOption = 'all_actions';
export const defaultStatusFilterOption = 'all_open';
export const documentAllOpenStatuses = [
  DocumentStatus.Draft,
  DocumentStatus.For_Review,
  DocumentStatus.For_Approval,
  DocumentStatus.Approved,
  DocumentStatus.Approval_Declined,
  DocumentStatus.Effective,
];

// Periodic review is excluded here; it is only fetched when explicitly selected.
export const defaultActionFilters = [
  'include_pending_review',
  'include_pending_approve',
  'include_pending_make_effective',
];

export const resolveActionFilters = (
  action: string | null | undefined,
): string[] =>
  action && action !== defaultActionFilterOption
    ? [action]
    : defaultActionFilters;

export const resolveStatusFilters = (
  status: string | null | undefined,
): DocumentStatus[] =>
  status && status !== defaultStatusFilterOption
    ? [status as DocumentStatus]
    : documentAllOpenStatuses;
